<script lang="ts">
    import {pipe} from '../../../../../svelte/utils';
    import {loc, recordDetailPath} from '../../../../../svelte/pipes';

    export let value;
</script>

<template>
    <a href={pipe(value, recordDetailPath())} target="_blank" rel="noreferrer">{pipe(value, loc())}</a>
</template>